import http from '@/requests/http'

class Blacklist {
  static all () {
    return http.post('blacklist/index')
  }
  static store (params) {
    return http.post('blacklist/store', params)
  }
  static destroy (params) {
    return http.post('blacklist/destroy', params)
  }
}

export default Blacklist
